import TextField from 'apollo-react/components/TextField';
import React from 'react';

const IntegerFilter = ({ accessor, filters, updateFilterValue }) => {
  return (
    <TextField
      value={filters[accessor]}
      name={accessor}
      onChange={updateFilterValue}
      type="number"
      style={{ width: 74 }}
      size="small"
      margin="none"
    />
  );
};

export default IntegerFilter;
